module.exports = __webpack_public_path__ + "img/hz.ffe0001a.png";